// @flow
import ProductConfiguration from '../../../types/product-configuration'
import type { DateString } from '../../../types/date-string'
import type { Product } from '../../../types/filter-entity/product'
import type { CustomerGroup } from '../../../types/filter-entity/customer-group'
import type { Term } from '../../../types/filter-entity/term'
import type { Stop } from '../../../types/filter-entity/stop'
import type { ConfigurationFilterEntitySet } from '../../../types/configuration-filter-entity-set'
import type { ProductClass } from '../../../types/filter-entity/class'
import type { StarValue } from '../../../types/filter-entity/star-value'
import type { Zone } from '../../../types/filter-entity/zone'
import type { Period } from '../../../types/period'

export type ConfigurationState = {
  availableFilterEntities: ConfigurationFilterEntitySet,
  dateEffective: ?DateString,
  selectedProduct: ?Product,
  selectedCustomerGroup: ?CustomerGroup,
  selectedTerm: ?Term,
  selectedFromStop: ?Stop,
  selectedToStop: ?Stop,
  selectedClass: ?ProductClass,
  selectedStarValue: ?StarValue,
  selectedZone: ?Zone,
  coveredPeriod: ?Period,
  expiryReminder: boolean,
  engravedId: string,
  renewSubscriptionId: ?string,
  preSelectedZoneId: ?string, // used to set the id of a to-be-selected zone, before the available zones have been loaded
  preSelectedZoneCode: ?string, // used to set the id of a to-be-selected zone, before the available zones have been loaded
  preSelectedStarValueId: ?string, // used to set the id of a to-be-selected starValue, before the available starValues have been loaded
  preSelectedClassId: ?string,
  preSelectedFromStopId: ?string,
  preSelectedToStopId: ?string,
  specialSaleSlug: ?string,
  productConfigurations: ProductConfiguration[],
  sessionId: ?string
}

const state: ConfigurationState = {
  availableFilterEntities: {
    customerGroups: [],
    classes: [],
    terms: [],
    zones: [],
    starValues: [],
    stops: []
  },
  dateEffective: null,
  selectedProduct: null,
  selectedCustomerGroup: null,
  selectedTerm: null,
  selectedFromStop: null,
  preSelectedFromStopId: null,
  selectedToStop: null,
  preSelectedToStopId: null,
  selectedClass: null,
  preSelectedClassId: null,
  selectedStarValue: null,
  preSelectedStarValueId: null,
  selectedZone: null,
  preSelectedZoneId: null,
  preSelectedZoneCode: null,
  coveredPeriod: null,
  expiryReminder: true,
  engravedId: '',
  renewSubscriptionId: null,
  specialSaleSlug: null,
  productConfigurations: [],
  sessionId: null
}

export default state



// WEBPACK FOOTER //
// ./src/store/modules/configuration/state.js